// GET ADMIN CONFIG
export const GET_ADMIN_CONFIG_REQUEST = 'GET_ADMIN_CONFIG_REQUEST';
export const GET_ADMIN_CONFIG_SUCCESS = 'GET_ADMIN_CONFIG_SUCCESS';
export const GET_ADMIN_CONFIG_FAIL = 'GET_ADMIN_CONFIG_FAIL';

// EXPORT QUOTATIONS STATS
export const EXPORT_QUOTATIONS_STATS_REQUEST = 'EXPORT_QUOTATIONS_STATS_REQUEST';
export const EXPORT_QUOTATIONS_STATS_SUCCESS = 'EXPORT_QUOTATIONS_STATS_SUCCESS';
export const EXPORT_QUOTATIONS_STATS_FAIL = 'EXPORT_QUOTATIONS_STATS_FAIL';
